import type { FC, ReactNode } from 'react';
import { Box } from '@mui/material';

interface Props {
  children?: ReactNode;
  index: number;
  value: number;
}

const TabPanel: FC<React.PropsWithChildren<Props>> = ({ children, value, index, ...other }) => {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
};

export default TabPanel;
